import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class PlatformService {
    private readonly platformId = inject(PLATFORM_ID);

    public isPlatformServer(): boolean {
        return isPlatformServer(this.platformId);
    }

    public isPlatformBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }
}
